(function () {
    'use strict';
    angular
        .module('backApp')
        .factory('Qinius', Qinius)
        .factory("Convert", Convert)
        .factory('Category', Category);

    Category.$inject = ['$resource'];
    Convert.$inject = ['$resource'];
    Qinius.$inject = ['$resource'];

    function Qinius($resource) {
        var resourceUrl = 'manager/' + 'api/qiniu/:path/:storeId';
        var service = $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: {
                    path: 'upload-token'
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getDomain': {
                method: 'GET',
                params: {
                    path: 'bucket-domains'
                }
            },
        });
        return service;
    }

    function Convert ($resource) {
        var resourceUrl =  'fileserves/' + 'api/convert/:path/:storeId';

        return $resource(resourceUrl, {}, {
            "xmlToDocument":{
                method:"GET",
                params:{
                    path:"xmlToDocument"
                }
            },
            "imageFormat":{
                method:"GET",
                params:{
                    path:"imageFormat"
                }
            },
            "imgFilter":{
                method: 'GET',
                params: {
                    path: "filter"
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'documentToImg': {
                method: 'POST',
                params: {
                    path: 'documentToImg'
                },
                isArray: true
            },
        });
    }

    function Category($resource) {
        var resourceUrl = 'manager/' + 'api/categories/:store/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "categoryStoreCreate": {
                method: "POST",
                params: {
                    path: "store"
                }
            },
            'storeByCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition',
                    store:"store"
                }
            },
            "storeGetAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition",
                    store:"store"
                }
            },
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            }
        });
    }

})();
